import { styles, ButtonLayoutTheme, variants } from '../ButtonLayoutStyles.css';
import { baseTheme } from './ButtonLayoutBaseTheme.css';
import { multiVariantStyles } from './ButtonLayoutVariants.css';
/*******************
 * Component Theme
 *******************/

const ButtonLayoutRedwoodTheme: ButtonLayoutTheme = {
  multiVariantStyles,
  baseTheme,
  styles,
  variants
};

/*******************
 * Exports
 *******************/

export { ButtonLayoutRedwoodTheme };
